import {
  chartNames,
  colors,
  errorMetricsColors,
  metricsColors,
  settingNames,
  strCode
} from "../../consts";

const chartMetricsConfig = [
  {
    id: chartNames.PAGE_LOADS,
    metrics: {
      count: {
        id: "count",
        name: strCode.PAGE_LOADS_LABEL,
        color: metricsColors.BLUE
      },
      duration: {
        id: "duration",
        name: strCode.DURATION_LABEL,
        unit: "ms",
        color: metricsColors.GREEN
      }
    }
  },
  {
    id: chartNames.DIAGNOSTICS_ERRORS_READING_PERFOMANCE,
    metrics: {
      diagnostics: {
        id: "diagnostics",
        name: strCode.AVERAGE_LABEL,
        color: metricsColors.BLUE
      },
      speed: {
        id: "speed",
        name: strCode.SPEED_LABEL,
        unit: "s",
        isRightYAxis: true,
        color: metricsColors.GREEN
      }
    }
  },
  {
    id: chartNames.OS,
    metrics: {
      windows: {
        id: "Windows",
        name: "Windows",
        color: '#080B20',
      },
      android: {
        id: "Android",
        name: "Android",
        color: '#404FCF',
      },
      linux: {
        id: "Linux",
        name: "Linux",
        color: '#CFD2F0',
      },
      macos: {
        id: "macOS",
        name: "macOS",
        color: '#9CA3E6',
      },
      ios: {
        id: "iOS",
        name: "iOS",
        color: '#26328E',
      },
      other: {
        id: "Other",
        name: "Other",
        color: '#D6D6D8',
      }
    }
  },
  {
    id: chartNames.BROWSER,
    metrics: {
      chrome: {
        id: "Google Chrome",
        name: "Google Chrome",
        color: '#2BBA99',
      },
      edge: {
        id: "Microsoft Edge",
        name: "Microsoft Edge",
        color: '#D4F2EB',
      },
      safari: {
        id: "Safari",
        name: "Safari",
        color: '#94DEC9',
      },
      firefox: {
        id: "Mozilla Firefox",
        name: "Mozilla Firefox",
        color: '#306252',
      },
      opera: {
        id: "Opera",
        name: "Opera",
        color: '#17312A',
      },
      bluefy: {
        id: "Bluefy",
        name: "Bluefy",
        color: '#49937C',
      },
      other: {
        id: "Other",
        name: "Other",
        color: '#49937C',
      }
    }
  },
  {
    id: chartNames.DIAGNOSTICS_PERFORMANCE,
    metrics: {
      diagnostics: {
        id: "diagnostics",
        name: strCode.DIAGNOSTICS_LABEL,
        color: metricsColors.BLUE
      },
      speed: {
        id: "speed",
        name: strCode.SPEED_LABEL,
        unit: "s",
        isRightYAxis: true,
        color: metricsColors.GREEN
      }
    }
  },
  {
    id: chartNames.SETTING_USAGE,
    metrics: {
      successful: {
        id: "successful",
        name: strCode.SUCCESSFUL_LABEL,
        color: metricsColors.GREEN
      },
      failed: {
        id: "failed",
        name: strCode.FAILED_LABEL,
        color: metricsColors.RED
      }
    }
  },
  {
    id: chartNames.FWU_STATISTICS,
    metrics: {
      successful: {
        id: "successful",
        name: strCode.SUCCESSFUL_FWU_LABEL,
        color: metricsColors.GREEN
      },
      successfulNotReconnected: {
        id: "successfulNotReconnected",
        name: strCode.SUCCESSFUL_NOT_RECONNECTED_FWU_LABEL,
        color: metricsColors.YELLOW
      },
      failed: {
        id: "failed",
        name: strCode.FAILED_FWU_LABEL,
        color: metricsColors.RED
      }
    }
  },
  {
    id: chartNames.FWU_PERFORMANCE,
    metrics: {
      fwUpdates: {
        id: "fwUpdates",
        name: strCode.AMOUNT_OF_FWU_LABEL,
        color: metricsColors.BLUE
      },
      speed: {
        id: "speed",
        name: strCode.SPEED_LABEL,
        unit: "s",
        isRightYAxis: true,
        color: metricsColors.GREEN
      }
    }
  },
  {
    id: chartNames.FWU_COUNT,
    metrics: {
      successful: {
        id: "successful",
        name: strCode.SUCCESSFUL_FWU_LABEL,
        color: metricsColors.GREEN
      },
      successfulNotReconnected: {
        id: "successfulNotReconnected",
        name: strCode.SUCCESSFUL_NOT_RECONNECTED_FWU_LABEL,
        color: metricsColors.YELLOW
      },
      failed: {
        id: "failed",
        name: strCode.FAILED_FWU_LABEL,
        color: metricsColors.RED
      }
    }
  },
  {
    id: chartNames.FWU_ERRORS,
    metrics: {
      general: {
        id: "general",
        name: strCode.GENERAL_FWU_ERRORS_LABEL,
        color: errorMetricsColors.ERROR_100
      },
      timeout: {
        id: "timeout",
        name: strCode.TIMEOUT_FWU_ERRORS_LABEL,
        color: errorMetricsColors.ERROR_80
      },
      cm: {
        id: "cm",
        name: strCode.CM_FWU_ERRORS_LABEL,
        color: errorMetricsColors.ERROR_60
      },
      battery: {
        id: "battery",
        name: strCode.BATTERY_FWU_ERRORS_LABEL,
        color: errorMetricsColors.ERROR_40
      },
      other: {
        id: "other",
        name: strCode.OTHER_FWU_ERRORS_LABEL,
        color: errorMetricsColors.ERROR_20
      }
    }
  },
  {
    id: chartNames.RECONNECTION_TIME_DURING_FWU,
    metrics: {
      mono: {
        id: "mono",
        name: strCode.MONO_DEVICES_LABEL,
        unit: "s",
        color: metricsColors.BLACK
      },
      charger: {
        id: "charger",
        name: strCode.CHARGER_LABEL,
        unit: "s",
        color: metricsColors.LIGHT_BLUE
      },
      holder: {
        id: "holder",
        name: strCode.HOLDER_LABEL,
        unit: "s",
        color: metricsColors.BLUE
      }
    }
  },
  {
    id: chartNames.CONNECTION_TIME,
    metrics: {
      mono: {
        id: "mono",
        name: strCode.MONO_DEVICES_LABEL,
        unit: "s",
        color: metricsColors.BLACK
      },
      duo: {
        id: "duo",
        name: strCode.DUO_DEVICES_LABEL,
        unit: "s",
        color: metricsColors.LIGHT_BLUE
      }
    }
  },
  {
    id: chartNames.IQOS_DEVICE_USAGE,
    metrics: {
      mono: {
        id: "mono",
        name: strCode.MONO_DEVICES_LABEL,
        color: metricsColors.BLACK
      },
      duo: {
        id: "duo",
        name: strCode.DUO_DEVICES_LABEL,
        color: metricsColors.LIGHT_BLUE
      }
    }
  },
  {
    id: chartNames.IQOS_DEVICE_CONNECTIONS_COUNT,
    metrics: {
      windows: {
        id: "windows",
        name: "Windows",
        color: metricsColors.BLUE
      },
      android: {
        id: "android",
        name: "Android",
        color: metricsColors.LIGHT_BLUE
      },
      linux: {
        id: "linux",
        name: "Linux",
        color: metricsColors.GRAY
      },
      macos: {
        id: "macos",
        name: "macOS",
        color: metricsColors.GREEN
      }
    }
  },
  {
    id: chartNames.AD_STATISTICS,
    metrics: {
      mono: {
        id: "mono",
        name: strCode.MONO_DEVICES_LABEL,
        color: metricsColors.BLACK
      },
      charger: {
        id: "charger",
        name: strCode.CHARGER_LABEL,
        color: metricsColors.LIGHT_BLUE
      },
      holder: {
        id: "holder",
        name: strCode.HOLDER_LABEL,
        color: metricsColors.BLUE
      }
    }
  },
  {
    id: chartNames.AD_COUNT,
    metrics: {
      workingProperly: {
        id: "workingProperly",
        name: strCode.WORKING_PROPERLY_LABEL,
        color: metricsColors.GREEN
      },
      defective: {
        id: "defective",
        name: strCode.DEFECTIVE_LABEL,
        color: metricsColors.YELLOW
      },
      unknown: {
        id: "unknown",
        name: strCode.UNKNOWN_LABEL,
        color: colors.RAISIN_40
      },
      undefined: {
        id: "undefined",
        name: strCode.UNDEFINED_LABEL,
        color: colors.RAISIN_70
      },
      failed: {
        id: "failed",
        name: strCode.FAILED_LABEL,
        color: metricsColors.RED
      }
    }
  },
  {
    id: chartNames.BATTERY_HEALTH_STATISTICS,
    metrics: {
      successful: {
        id: "successful",
        name: strCode.SUCCESSFUL_LABEL,
        color: metricsColors.GREEN
      },
      failed: {
        id: "failed",
        name: strCode.FAILED_LABEL,
        color: metricsColors.RED
      }
    }
  },
  {
    id: chartNames.BATTERY_HEALTH_PERFORMANCE,
    metrics: {
      batteryHealth: {
        id: "batteryHealth",
        name: strCode.BATTERY_HEALTH_LABEL,
        color: metricsColors.BLUE
      },
      speed: {
        id: "speed",
        name: strCode.SPEED_LABEL,
        unit: "s",
        isRightYAxis: true,
        color: metricsColors.GREEN
      }
    }
  },
  {
    id: chartNames.SETTING_PERFOMANCE,
    metrics: {
      [settingNames.LED_MODE]: {
        id:settingNames.LED_MODE,
        name: strCode.LED_MODE_COUNT_LABEL,
        color: metricsColors.BLUE
      },
      [settingNames.VIBRATION_MODE]: {
        id: settingNames.VIBRATION_MODE,
        name: strCode.VIBRATION_MODE_COUNT_LABEL,
        color: metricsColors.BLUE
      },
      [settingNames.CLEANING_MODE]: {
        id: settingNames.CLEANING_MODE,
        name: strCode.CLEANING_MODE_COUNT_LABEL,
        color: metricsColors.BLUE
      },
      [settingNames.RESPONSIVE_DRAW]: {
        id: settingNames.RESPONSIVE_DRAW,
        name: strCode.RESPONSIVE_DRAW_COUNT_LABEL,
        color: metricsColors.BLUE
      },
      [settingNames.VAPE_CLOUD_SIZE]: {
        id: settingNames.VAPE_CLOUD_SIZE,
        name: strCode.VAPE_CLOUD_SIZE_COUNT_LABEL,
        color: metricsColors.BLUE
      },
      [settingNames.AUTO_START]: {
        id: settingNames.AUTO_START,
        name: strCode.AUTO_START_COUNT_LABEL,
        color: metricsColors.BLUE
      },
      [settingNames.SMART_GESTURES]: {
        id: settingNames.SMART_GESTURES,
        name: strCode.SMART_GESTURES_COUNT_LABEL,
        color: metricsColors.BLUE
      },
      [settingNames.RESTART_MODE]: {
        id: settingNames.RESTART_MODE,
        name: strCode.RESTART_MODE_COUNT_LABEL,
        color: metricsColors.BLUE
      },
      speed: {
        id: "speed",
        name: strCode.SPEED_LABEL,
        unit: "s",
        isRightYAxis: true,
        color: metricsColors.GREEN
      }
    }
  }
];

export default chartMetricsConfig;
